'use strict';
define([], function () {
    AeoCheckerController.$inject = ['$filter', 'AeoService', '$translate'];

    function AeoCheckerController($filter, AeoService, $translate) {
        var ctrl = this;
        var ringRadius = 34;
        var ringCircumference = 2 * Math.PI * ringRadius;
        var gaugeCircumference = Math.PI * 80;
        var categoryDefinitions = [
            {id: 'discoverability', labelKey: 'workspace.aeoCategoryDiscoverability', icon: 'ti ti-search'},
            {id: 'contentAccessibility', labelKey: 'workspace.aeoCategoryContent', icon: 'ti ti-markdown'},
            {id: 'botAccessControl', labelKey: 'workspace.aeoCategoryBotAccess', icon: 'ti ti-shield-lock'},
            {id: 'discovery', labelKey: 'workspace.aeoCategoryDiscovery', icon: 'ti ti-route'},
            {id: 'commerce', labelKey: 'workspace.aeoCategoryCommerce', icon: 'ti ti-shopping-cart'}
        ];
        var checkLabels = {
            robotsTxt: 'workspace.aeoCheckRobotsTxt',
            sitemap: 'workspace.aeoCheckSitemap',
            linkHeaders: 'workspace.aeoCheckLinkHeaders',
            dnsAid: 'workspace.aeoCheckDnsAid',
            markdownNegotiation: 'workspace.aeoCheckMarkdownNegotiation',
            robotsTxtAiRules: 'workspace.aeoCheckRobotsTxtAiRules',
            contentSignals: 'workspace.aeoCheckContentSignals',
            webBotAuth: 'workspace.aeoCheckWebBotAuth',
            apiCatalog: 'workspace.aeoCheckApiCatalog',
            oauthDiscovery: 'workspace.aeoCheckOauthDiscovery',
            oauthProtectedResource: 'workspace.aeoCheckOauthProtectedResource',
            authMd: 'workspace.aeoCheckAuthMd',
            mcpServerCard: 'workspace.aeoCheckMcpServerCard',
            a2aAgentCard: 'workspace.aeoCheckA2aAgentCard',
            agentSkills: 'workspace.aeoCheckAgentSkills',
            webMcp: 'workspace.aeoCheckWebMcp',
            ard: 'workspace.aeoCheckArd',
            personalAgentProtocol: 'workspace.aeoCheckPersonalAgentProtocol',
            x402: 'workspace.aeoCheckX402',
            mpp: 'workspace.aeoCheckMpp',
            ucp: 'workspace.aeoCheckUcp',
            acp: 'workspace.aeoCheckAcp',
            ap2: 'workspace.aeoCheckAp2'
        };

        ctrl.$onInit = function () {
            if (ctrl.projectUrl) ctrl.scan();
        };
        ctrl.projectDomain = function () {
            return String(ctrl.projectUrl || '')
                .replace(/^https?:\/\//i, '')
                .replace(/^www\./i, '')
                .split('/')[0];
        };
        ctrl.$onChanges = function (changes) {
            if (changes.projectUrl && !changes.projectUrl.isFirstChange() && ctrl.projectUrl) {
                ctrl.scan();
            }
        };
        ctrl.scan = function () {
            if (!ctrl.projectUrl || ctrl.loading) return;
            ctrl.loading = true;
            ctrl.error = null;
            ctrl.result = null;
            ctrl.categories = [];
            ctrl.score = 0;
            AeoService.scan(ctrl.projectUrl)
                .then(function (result) {
                    ctrl.result = result;
                    ctrl.scannedAt = result.scannedAt ? $filter('date')(result.scannedAt, 'dd/MM/yyyy HH:mm') : null;
                    ctrl.categories = categoryDefinitions.map(function (category) {
                        var checks = result.checks && result.checks[category.id] || {};
                        var rows = Object.keys(checks).map(function (key) {
                            var check = checks[key] || {};
                            return {
                                key: key,
                                label: checkLabels[key] ? $translate.instant(checkLabels[key]) : key,
                                message: localizedMessage(check.status),
                                status: check.status || 'neutral'
                            };
                        });
                        var passed = rows.filter(function (row) { return row.status === 'pass'; }).length;
                        var eligible = rows.filter(function (row) { return row.status !== 'neutral'; }).length;
                        var pct = eligible ? (passed / eligible) * 100 : 0;
                        return {
                            id: category.id,
                            label: $translate.instant(category.labelKey),
                            icon: category.icon,
                            rows: rows,
                            passed: passed,
                            eligible: eligible,
                            pct: pct,
                            ringDash: eligible ? (passed / eligible) * ringCircumference : 0,
                            ringColor: scoreColor(pct),
                            notChecked: !eligible
                        };
                    });
                    var passed = ctrl.categories.reduce(function (sum, category) { return sum + category.passed; }, 0);
                    var eligible = ctrl.categories.reduce(function (sum, category) { return sum + category.eligible; }, 0);
                    ctrl.score = typeof result.score === 'number'
                        ? Math.round(result.score)
                        : (eligible ? Math.round((passed / eligible) * 100) : 0);
                    ctrl.scoreColor = scoreColor(ctrl.score);
                    ctrl.gaugeDash = (ctrl.score / 100) * gaugeCircumference;
                    ctrl.levelName = levelName(result.level);
                    ctrl.nextLevelName = result.nextLevel ? levelName(result.nextLevel.target) : '';
                })
                .catch(function () {
                    ctrl.error = $translate.instant('workspace.aeoScanUnavailable');
                })
                .finally(function () {
                    ctrl.loading = false;
                });
        };
        function scoreColor(value) {
            if (value >= 75) return 'var(--sto-color-success)';
            if (value >= 50) return 'var(--sto-color-warning)';
            return 'var(--sto-color-critical)';
        }
        ctrl.statusLabel = function (status) {
            if (status === 'pass') return $translate.instant('workspace.aeoStatusPass');
            if (status === 'fail') return $translate.instant('workspace.aeoStatusFail');
            return $translate.instant('workspace.aeoStatusNeutral');
        };
        ctrl.checkLabel = function (key) {
            return checkLabels[key] ? $translate.instant(checkLabels[key]) : key;
        };
        ctrl.statusIcon = function (status) {
            if (status === 'pass') return 'ti ti-circle-check';
            if (status === 'fail') return 'ti ti-circle-x';
            return 'ti ti-info-circle';
        };
        function localizedMessage(status) {
            if (status === 'pass') return $translate.instant('workspace.aeoCheckPassed');
            if (status === 'fail') return $translate.instant('workspace.aeoCheckFailed');
            return $translate.instant('workspace.aeoCheckNeutral');
        }
        function levelName(level) {
            var safeLevel = Math.max(0, Math.min(6, Number(level) || 0));
            return $translate.instant('workspace.aeoLevel' + safeLevel);
        }
    }

    return {
        controller: AeoCheckerController,
        templateUrl: 'app/modules/project/components/aeo-checker/aeo-checker.html',
        bindings: {
            projectUrl: '<'
        }
    };
});
